export const shorten = (str: string, start = 0, end = 0) => {
  const strLen = (str || '').length;
  if (!strLen || !start || start >= strLen || start + end >= strLen) return str;

  const startStr = str.substr(0, start);
  const endStr = end ? str.substr(-end) : '';

  return `${startStr}…${endStr}`;
};

// only valid for all char is ascii
export function shorthex2ascii(input: string) {
  const hexes = input.match(/.{1,2}/g) || [];
  let back = '';
  for (let i = 0; i < hexes.length; i++) {
    back += String.fromCharCode(parseInt(hexes[i], 16));
  }

  return back;
}

export const uppercaseFirstLetter = (arg = '') => {
  const _arg = arg.trim();

  return `${_arg[0]?.toUpperCase() || ''}${_arg.slice(1)}`;
};
